import Vue from 'vue'
import { UserService} from '@/common/api.service'
import { SortUtils } from '@/common/utils.js'

import {
    FETCH_USER,
    FETCH_USERS,
    FETCH_PARTNER,
    USER_RESET_STATE
} from './actions.type'

import {
    SET_USER,
    SET_USERS,
    SET_PARTNER_ID,
    RESET_USER_STATE,
} from './mutations.type'

const initialState = {
    user: {},
    users: [],
    partnerId: null
}

export const state = Object.assign({}, initialState)

export const actions = {
    [FETCH_USER] (context) {
        if(state.user !== {}) {
            return UserService.get('me')
            .then(({ data }) => {
                context.commit(SET_USER, data)
                return data
            })
        }
    },
    [FETCH_USERS] (context) {
        return UserService.get()
        .then(({ data }) => {
            let sortedData = SortUtils.sortAsc(data, {prop: 'name'})
            context.commit(SET_USERS, sortedData)
        })
    },
    [FETCH_PARTNER] (context, partnerId) {
        context.commit(SET_PARTNER_ID, partnerId)
    },
    [USER_RESET_STATE] ({ commit }) {
        commit(RESET_STATE)
    }
}

export const mutations = {
    [SET_USER] (state, user) {
        state.user = user
    },
    [SET_USERS] (state, users) {
        state.users = users
    },
    [SET_PARTNER_ID] (state, partnerId) {
        state.partnerId = partnerId
    },
    [RESET_USER_STATE] () {
        for (let f in state) {
          Vue.set(state, f, initialState[f])
        }
    }
}

const getters = {
    user (state) {
        return state.user
    },
    users (state) {
        return state.users
    },
    partnerId (state) {
        return state.partnerId
    }
  }

export default {
    state,
    actions,
    mutations,
    getters
}